import { FC } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { noop } from 'lodash';
import { Optional, Overwrite } from 'utility-types';
import {
  createBemBlockBuilder,
  PageErrorMessage as PageErrorMessageComponent,
} from '@ebsco-ui/ebsco-ui';
import { PageErrorMessageProps as PageErrorMessageComponentProps } from '@ebsco-ui/page-error-message';

import { sharedMessages } from '@app/translations';

import './PageErrorMessage.scss';

const cnBem = createBemBlockBuilder(['pageErrorMessage']);

type PageErrorMessageProps = Optional<
  Overwrite<PageErrorMessageComponentProps, { onClick?: () => void }>,
  'title'
>;

export const PageErrorMessage: FC<PageErrorMessageProps> = props => {
  const { $t } = useIntl();
  const {
    title = $t(sharedMessages.pageUnavailable),
    text = $t(sharedMessages.searchUnavailableText),
    buttonText = $t(sharedMessages.refreshPage),
    className,
    onClick = noop,
    ...rest
  } = props;

  return (
    <PageErrorMessageComponent
      className={cn(cnBem(), className)}
      title={title}
      text={text}
      buttonText={buttonText}
      onClick={() => onClick()}
      {...rest}
    />
  );
};
